import CustomForm from "../common/components/CustomForm";
import { DefaultButton } from "../common/components/DefaultButton";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import JobTable from "./JobTable";
import Card from "../common/components/Card";
import { Modal } from "../common/utils/dialogUtlities";
import { deepClone } from "../common/utils/objectUtilities";

const DecisionDialog = ({ decision: inputDecision, disabled, onClose }) => {
    const { t } = useTranslation();
    const [decision, setDecision] = useState(deepClone(inputDecision));

    useEffect(() => {
        setDecision(deepClone(inputDecision));
    },[inputDecision])

    if (!decision) {
        return null;
    }

    const label = decision?.id ? t('decision', { count: 1 }) + ' #' + decision.id : t('newDecision');

    const handleChange = delta => {
        setDecision({ ...decision, data: { ...decision.data, ...delta } });
    }

    const handleAdd = job => {
        const jobs = decision.jobs ?? [];
        if (decision.jobs.every(j => j?.toString() !== jobs?.jobid?.toString())) {
            setDecision({ ...decision, jobs: [...jobs, job.jobid ]});
        }
    }

    const handleRemove = job => {
        if (decision.jobs) {
            setDecision({ ...decision, jobs: decision.jobs.filter(j => j.toString() !== job.jobid.toString() )});
        }
    }

    return <Modal show={true} size="xlg">
        <Modal.Header>
            {label}
        </Modal.Header>
        <Modal.Body style={{ height: 'calc(100dvh - 150px)', overflowY: 'scroll'}}>
            <CustomForm def={decision.definition} data={decision.data} disabled={disabled} onChange={handleChange}></CustomForm>
            <Card title={t('jobRelations')}>
                <JobTable jobs={decision.jobs ?? []} disabled={disabled} canSelect={() => false} onAdd={handleAdd} onRemove={handleRemove}></JobTable>
            </Card>
        </Modal.Body>
        <Modal.Footer>
            {disabled ? null : <DefaultButton kind="save" onClick={() => onClose?.(decision)}></DefaultButton>}
            <DefaultButton kind="close" onClick={() => onClose?.(null)}></DefaultButton>
        </Modal.Footer>
    </Modal>;
}

export default DecisionDialog;